import { render, staticRenderFns } from "./otp_history.vue?vue&type=template&id=33e4e838&"
import script from "./otp_history.vue?vue&type=script&lang=js&"
export * from "./otp_history.vue?vue&type=script&lang=js&"
import style0 from "./otp_history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports